export function formatCurrency({
  amount = 0,
  currency,
  locale,
  decimalCount,
}: {
  amount?: number | string;
  currency?: string;
  locale?: string;
  decimalCount?: number;
} = {}): string {
  const amountNumber = Number(amount);

  if (currency) {
    const fractionDigits = decimalCount ?? getDisplayPrecision(amountNumber);
    return Intl.NumberFormat(locale, {
      style: 'currency',
      unitDisplay: 'narrow',
      currency,
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }).format(amountNumber);
  }

  if (decimalCount) {
    return amountNumber.toFixed(decimalCount);
  }

  return String(amount);
}

function getDisplayPrecision(amount: number): number {
  return Number.isInteger(amount) ? 0 : 2;
}
